import * as constants from './constants';
import axiosInstance from "../../../../../../../utils/request";

export const changeMenu = (menu) => ({
    type: constants.CHANGE_MENU,
    menu
});

export const changeSelected = (trail) => {
    return {
        type: constants.CHANGE_SELECTED,
        ids: parseTrail(trail)
    }
};

const parseTrail = (trail) => {
    let tmpIds = trail.split('_');
    let ids = [];
    for (let i = 1; i < tmpIds.length; i++) {
        ids.push(parseInt(tmpIds[i]));
    }
    return ids;
}

export const getMenu = () => {
    return (dispatch) => {
        axiosInstance.get('/menu?force=1&is_tree=1').then((response) => {
            let result = response.data;
            if (result) {
                dispatch(changeMenu(result));
            }
        })
    }
}
